"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.AttachType = exports.ParamsKeys = void 0;
var ParamsKeys;
(function (ParamsKeys) {
    ParamsKeys["XEmail"] = "x-email";
    ParamsKeys["FolderId"] = "folder-id";
    ParamsKeys["BackUrl"] = "back_url";
})(ParamsKeys = exports.ParamsKeys || (exports.ParamsKeys = {}));
var AttachType;
(function (AttachType) {
    AttachType["Attach"] = "attach";
    AttachType["Cloud"] = "cloud";
    AttachType["CloudStock"] = "cloud_stock";
    AttachType["Temporary"] = "temporary";
})(AttachType = exports.AttachType || (exports.AttachType = {}));
var Errors;
(function (Errors) {
    Errors["Url"] = "err_url";
    Errors["Host"] = "err_host";
    Errors["Decode"] = "err_decode_url";
    Errors["Ids"] = "err_ids";
    Errors["AttachId"] = "err_attach_id";
    Errors["MessageId"] = "err_message_id";
    Errors["Email"] = "err_email";
    Errors["BackUrl"] = "err_back_url";
    Errors["FolderId"] = "err_folder_id";
    Errors["AttachType"] = "err_attach_type";
})(Errors = exports.Errors || (exports.Errors = {}));
//# sourceMappingURL=constants.js.map